import moment from "moment";
import { getWeekDaysFromDateRange } from "@/utils/dates";
import { getFormattedDateTimeString } from "@/utils/dateTimeFormat";
import { FacilitySettingsModel } from "@/models/FacilitySettings";

export default {
  name: "ReportEvents",
  data() {
    return {
      startDate: moment().subtract(1, "week").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      flexHeight: 270,
      picker: {
        start: false,
        end: false
      },
      eventsByIsVirtual: [],
      eventsPerVisitType: [],
      dailyCount: [],
      eventsByDate: [],
      eventsByOrganiserName: [],
      eventsByLocation: [],
      eventsByHour: [],
    }
  },
  computed: {
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    calenderEvents() {
      return this.$store.state.calenderModule.latestCalenderEvents;
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    }
  },
  mounted() {
    this.$store.dispatch("getSocialEvents", {
      startDate: moment(this.startDate).startOf('day').toDate(),
      endDate: moment(this.endDate).endOf('day').toDate(),
      loadAdditionalServices: true
    });
  },
  watch: {
    "calenderEvents"(calenderEvents) {
      this.eventsByDate = this.groupByDay(calenderEvents)
      this.dailyCount = this.getDailyCount(calenderEvents)
      this.eventsPerVisitType = this.getPerVisitType(calenderEvents)
      this.eventsByIsVirtual = this.groupByIsVirtual(calenderEvents)
      this.eventsByOrganiserName = this.groupByOrganiserName(calenderEvents)
      this.eventsByLocation = this.getByLocation(calenderEvents)
      this.eventsByHour = this.groupByHour(calenderEvents)
    }
  },
  methods: {
    routeToGuestbook() {
      this.$router.push("/reports");
    },
    getSocialEventsByDates() {
      console.log(this.startDate);
      console.log(this.endDate);
      this.$store.dispatch("getSocialEvents", {
        startDate: new Date(this.startDate),
        endDate: new Date(this.endDate),
        loadAdditionalServices: true
      });
    },
    getDailyCount(visits) {
      const types = visits.reduce(function (totals, visit) {
        const date = moment(visit.start)
          .startOf("day")
          .format("LL");
        !totals[date] ? (totals[date] = 1) : (totals[date] = totals[date] + 1);
        return totals;
      }, {});
      return types;
    },
    getEventsPerResident(events) {
      const res = events.reduce(function (totals, event) {
        if (event.attendees && event.attendees.length > 0)
          event.attendees.reduce(function (resTotal, attendee) {
            !totals[attendee.name]
              ? (totals[attendee.name] = 1)
              : (totals[attendee.name] = totals[attendee.name] + 1);
          }, {});

        return totals;
      }, {});
      return res;
    },
    getPerVisitType(visits) {
      const types = visits.reduce(function (totals, visit) {
        const key = visit?.inviteesDetails[0]?.name ?? "All";
        !totals[key]
          ? (totals[key] = 1)
          : (totals[key] = totals[key] + 1);
        return totals;
      }, {});
      return types;
    },
    getByLocation(visits) {
      const types = visits.reduce(function (totals, visit) {
        !totals[visit.location]
          ? (totals[visit.location] = 1)
          : (totals[visit.location] = totals[visit.location] + 1);
        return totals;
      }, {});
      return types;
    },
    groupByDay(events) {
      const weekDays = getWeekDaysFromDateRange(moment(this.startDate), moment(this.endDate))
      const week = weekDays.reduce((o, key) => ({ ...o, [key]: undefined }), {})
      const types = events.reduce(function (totals, event) {
        const dayOfWeek = moment(event.start).format("dddd");
        !week[dayOfWeek] ? (week[dayOfWeek] = 1) : (week[dayOfWeek] = totals[dayOfWeek] + 1);
        return week;
      }, {});
      return types;
    },
    groupByHour(visits) {
      const types = visits.reduce(function (totals, visit) {
        const dayOfWeek = moment(visit.start).format("HH");
        !totals[dayOfWeek]
          ? (totals[dayOfWeek] = 1)
          : (totals[dayOfWeek] = totals[dayOfWeek] + 1);
        return totals;
      }, {});
      return types;
    },
    groupByIsVirtual(visits) {
      const types = visits.reduce(function (totals, visit) {
        !totals[visit.isVirtualEvent ? "Virtual" : "In Person"]
          ? (totals[visit.isVirtualEvent ? "Virtual" : "In Person"] = 1)
          : (totals[visit.isVirtualEvent ? "Virtual" : "In Person"] =
            totals[visit.isVirtualEvent ? "Virtual" : "In Person"] + 1);
        return totals;
      }, {});
      return types;
    },
    groupByOrganiserName(visits) {
      const types = visits.reduce(function (totals, visit) {
        !totals[visit.organiserName]
          ? (totals[visit.organiserName] = 1)
          : (totals[visit.organiserName] = totals[visit.organiserName] + 1);
        return totals;
      }, {});
      return types;
    },
    residentsDeclinedInvitation(events) {
      const res = events.reduce(function (totals, event) {
        if (event.notGoingDetails && event.notGoingDetails.length > 0)
          event.notGoingDetails.reduce(function (resTotal, notGoingDetail) {
            !totals[notGoingDetail.name]
              ? (totals[notGoingDetail.name] = 1)
              : (totals[notGoingDetail.name] = totals[notGoingDetail.name] + 1);
          }, {});

        return totals;
      }, {});
      return res;
    },
    formattedDateTimeString(date: Date, addYears: boolean, addTime: boolean) {
      if(!this.facility) return ''

      return getFormattedDateTimeString(date, this.facility.dateFormat, addTime?this.facility.timeFormat: null, addYears);
    },
  }
}